import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setLicenceValidity, setPrivacyPolicyStatus } from "../reducers/licence";

export { setLicenceValidity, setPrivacyPolicyStatus };

export function checkIfPrivacyPolicyAccepted() {
  return async (dispatch) => {
    try {
      const response = await axiosWrapper.get(`${getBackendUrl()}/globalSettings/isUserAcceptedPrivayPolicy`);
      if (!response.data.status) {
        dispatch(setPrivacyPolicyStatus(response.data));
      }
    } catch {
      // ignore error
    }
  };
}
